export default __webpack_public_path__ + "static/media/planet4.7b153ef8.webp";